import {
	VendorClientContactRequest,
	VendorClientContactResponse,
	getTableQueryFilters,
	TableQueryFilter,
	TableQueryFilterOperands
} from "@/Contracts";
import { getRequest } from "@/Utils";
import axios, { AxiosResponse } from "axios";
const getVendorClientContactDetailsURL = "/v1/vendor/client/users";

export const getAllVendorClientContacts = async (
	clientContactRequest: VendorClientContactRequest
): Promise<VendorClientContactResponse> => {
	try {
		let url = getVendorClientContactDetailsURL;
		const appliedFilters = getTableQueryFilters(
			[
				...(!!clientContactRequest.filters.length
					? clientContactRequest.filters
					: []),
				new TableQueryFilter(
					TableQueryFilterOperands.MongoDbEqualTo,
					"vendor_client_company_id",
					clientContactRequest.clientId,
					null,
					true
				)
			],
			false
		);
		url =
			url +
			"?" +
			appliedFilters +
			`&page=${clientContactRequest.page}&limit=${clientContactRequest.limit}`;

		if (clientContactRequest.keywords) {
			url = url + `&q=${clientContactRequest.keywords}`;
		}
		if (clientContactRequest.selected_id) {
			url =
				url +
				`&selected_id=${clientContactRequest.selected_id.join(",")}`;
		}

		const response: AxiosResponse<VendorClientContactResponse> =
			await axios(getRequest(url, null, true, true, false));
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
